import {Component, ViewChild} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {RoleService} from "../../services/role.service";
import {MatTableGeneratorComponent} from "../../shared/mat-table-generator/mat-table-generator.component";
import {MultiCrudDataSource} from "../../table-datasouces/multi-crud.datasource";
import {Customer} from "../../dto/customer";
import {FormControl} from "@angular/forms";
import {IdentStatus} from "../../dto/ident-status";
import {CompanyService} from "../services/company.service";
import {Company} from "../../dto/company";
import {NewsletterService} from "../services/newsletter.service";
import {Newsletter} from "../../dto/newsletter";
import {DatePipe} from "@angular/common";
import {AppMatCustomAction} from "../../shared/mat-table-generator/mat-table-core/app-mat-custom-action";
import {ConfirmDialogComponent} from "../../shared/confirm-dialog/confirm-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {ToastService} from "angular-toastify";
import {NewsletterType} from "../../dto/newsletter-type";

@Component({
  selector: 'app-send-email',
  templateUrl: './sendemail.component.html',
  styleUrls: ['./sendemail.component.css']
})
export class SendEmailComponent {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private roleService: RoleService,
    private newsletterService: NewsletterService,
    public companiesService: CompanyService,
    private datePipe: DatePipe,
    private dialog: MatDialog,
    private _toastService: ToastService,

  ) { }



  public webIdStatusSelect = new FormControl();
  public companySelect = new FormControl();
  public companies: Company[];
  public webIdStatus = IdentStatus;
  @ViewChild(MatTableGeneratorComponent, { static: true }) table: MatTableGeneratorComponent;

  dataSource = new MultiCrudDataSource(this.newsletterService);
  columns = [

    { cell: (row: Newsletter) => false, columnDef: 'isActive', header: 'Approved', cellColor: (row: Newsletter) => row.isRecipientsManually ? 'dodgerblue' : false, icon: (row: Newsletter) => {
        if (row.isActive) {
return 'check';
}
        return 'close';
      } },
    { columnDef: 'name', header: 'Name', cell: (row: Newsletter) => `${row.name}` },
    { columnDef: 'type', header: 'Type', cell: (row: Newsletter) => {
      if ( row.type == NewsletterType.Email) return "E-Mail";
      if ( row.type == NewsletterType.Sms) return "Sms";
      if ( row.type == NewsletterType.Push) return "Push";

      return "UNKNOWN";
      }
    },
    { columnDef: 'sendDate', header: 'Send Date', cell: (row: Newsletter) => `${this.datePipe.transform(row.sendDate, 'dd.MM.yyyy HH:mm')}` },
    { columnDef: 'Status', header: 'Status', cellColor: (row: Newsletter) => row.isRecipientsManually ? 'dodgerblue' : false, cell: (row: Newsletter) => {
        if(row.isSent){
          return 'sent - '+row.sentCount;
        }

        if( row.isPreparing ) {
          return 'preparing';
        }

        if( row.isPrepared && !row.isSending ) {
          return 'prepared - ' + row.recipientsCount;
        }
        if(row.isSending){
          return 'sending - '+row.sentCount+'/'+(row.queuedCount+row.sentCount);
        }

        if ( row.isRecipientsManually ) {
return 'manual recipients - ' + row.recipientsCount;
}

      return '-';

      }
    },

    { cell: (row: Newsletter) => false, columnDef: 'isSent', header: 'Sent', icon: (row: Newsletter) => {
        if (row.isSent) {
return 'check';
}
        return 'close';
      } },

  ];

  ngOnInit() {
    this.rebuildSendMailCustomActions();
  }




  // WebIdEvent
  onWebStatusChange() {
    this.table.filters.enumFilter = {
      key: 'IdentStatus', value: this.webIdStatusSelect.value
    };
    this.triggerSearch();
  }

  onCompanyChange() {
    this.table.filters.someAdditionalData = 'companyid_' + this.companySelect.value; // TODO heavy abuse
    this.triggerSearch();
  }

  triggerSearch() {
    this.onSearch();
  }

  onSearch(isInvalid = false) {
    if (!isInvalid) {
      this.table.applyFilter();
    }
  }

  getPartnerId(row: Customer){
    let r = '';
    let c = 0;
    const array = row.orders.filter(x=> x.partnerCustomerId != null);
    const resArr = [];

    if(array.length > 0){
      row.orders.forEach((item) =>{
        const i = resArr.findIndex(x => x.partnerCustomerId == item.partnerCustomerId);
        if(i <= -1){
          if(c > 0){
            r = r + ', ';
          }
          resArr.push({id: item.id, name: item.partnerCustomerId});
          r = item.partnerCustomerId;
          c++;
        }

      });
    }


    return r == '' ? '-' : r;
  }

  currentUserIsPartner() {
    return this.roleService.hasRoles('partner');
  }

  getViewLink = (item: Newsletter): string => item.id.toString();

  getEditLink = (item: Newsletter): string => item.id.toString() + '/edit';

  editEnabled() {
    return this.roleService.hasRoles('admin');
  }

  deleteEnabled() {
    return false;
    return this.roleService.hasRoles('admin');
  }

  public sendMailCustomActions: AppMatCustomAction[] = [];

  rebuildSendMailCustomActions() {

    if (this.roleService.hasRoles('admin')) {
      this.sendMailCustomActions = [
        new AppMatCustomAction('content_copy', 'Copy template', false, (row: Newsletter) => {
          this.dialog.open(ConfirmDialogComponent, {
            data: {
              title: 'Copy template',
              text: 'Are you sure you want to copy the newsletter?'
            },
            minWidth: 350,
          })
            .afterClosed()
            .subscribe(result => {
              if (result == 'ok') {
                this.copyTemplate(row);
              }
            });
        }),

      ];
    }
  }

  private copyTemplate(newsletter: Newsletter) {
    this.newsletterService.copyTemplate(newsletter.id).subscribe(
      nlId => {

        this.triggerSearch();
        this._toastService.success('The newsletter has been copied');
      },
      err => {

          this._toastService.error(err.error.message || err.message || err.error || err);

      }
    );

  }
}

